import React, { useRef } from "react";
import Select from "../../Common/FormElements/Select/Select";
import TextInput from "../../Common/FormElements/TextInput/TextInput";
import { useTranslation } from "react-i18next";

const Interlocutor = ({
  el,
  index,
  interlocutor,
  getSelectValue,
  handleChange,
}) => {
  const { t } = useTranslation("common");

  return (
    <div className="col-6" key={el?.name}>
      {el.label && (
        <p className="f16 text-ultraBlack mb-2">{t(`${el?.label}`)}</p>
      )}
      {el.type === "select" ? (
        <Select
          {...el}
          label={el.label ? t(`${el.label}`) : ""}
          placeholder={el.placeholder ? t(`${el.placeholder}`) : ""}
          value={getSelectValue(interlocutor[el?.name], el.options ?? [])}
          options={(el.options ?? []).map((option) => ({
            name: t(`${option.name}`),
            code: option.code,
          }))}
          callback={handleChange(index)}
          appendToSelf
        />
      ) : (
        <TextInput
          {...el}
          label={el.label ? t(`${el.label}`) : ""}
          placeholder={el.placeholder ? t(`${el.placeholder}`) : ""}
          value={interlocutor[el?.name]}
          callback={handleChange(index)}
          disabled={el?.disabled}
        />
      )}
    </div>
  );
};

export default Interlocutor;
